import { Message } from "./../../shared/models/system/message";
import { Globals } from "src/app/shared/services/globals";
import { Component, OnInit } from "@angular/core";
import { Credentials } from "../../shared/models/credentials.interface";
import { Subscription } from "rxjs";
import { UserService } from "../services/user.service";
import { Router, ActivatedRoute } from "@angular/router";
import { finalize } from "rxjs/operators";
import { UserManagerService } from "../../shared/services/user-manager.service";
import { AuthGuard } from 'src/app/guards/auth.guard';
import { TranslateService } from '@ngx-translate/core';
import { PermissionRoleService } from "../services/permission-role.service";
import { Permission } from "src/app/shared/models/BasicData/Permission";
import { PatientService } from "src/app/basic-data/services/patient.service";
import { ActivationUserComponent } from "../activation-user/activation-user.component";
import { MatDialog } from '@angular/material';
import { ViewPatientRecordComponent } from "../../sas/view-patient-record/view-patient-record.component";
import { ToastrService } from "ngx-toastr";

//declare function search(): void;
//declare function Togglecard(): void;



@Component({
  selector: "app-login-form",
  templateUrl: "./login-form.component.html",
  styleUrls: ["./login-form.component.css"]
})
export class LoginFormComponent implements OnInit {
  private subscription: Subscription;

  showLogin: boolean = false;
  brandNew: boolean;
  errors: boolean = false;
  //loginFailed: Boolean = false;
  isRequesting: boolean;
  submitted: boolean = false;
  credentials: Credentials = { email: "", password: "" };
  patientActive: boolean;
  userId: any;
  destination: any;
  registeredEmail: any;
  constructor(
    private userService: UserService,
    private userManger: UserManagerService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public global: Globals,
    private permssionRole: PermissionRoleService,
    private _PatientService: PatientService,
    public dialog: MatDialog,
    translate: TranslateService, private toastr: ToastrService,
  ) {
    translate.setDefaultLang('AR');

  }

  login({ value, valid }: { value: Credentials; valid: boolean }) {
    this.submitted = true;
    this.isRequesting = true;
    this.global.spinner = true;
    //this.errors = "";
    // alert(value);
    // alert(valid);
    if (valid) {
      this.userService
        .login(value.email, value.password)
        .pipe(
          finalize(() => {
            this.isRequesting = false;
          })
        )
        .subscribe(
          result => {
            console.log(result);
            if (result.status === 1) {
              // this.errors = false;
              this.userManger.logout();
              this.userManger.saveToken(result.data.token);
              this.userManger.saveUserData(result.data);

              this.userManger.login();
              this.global.EmpCompleteData = result.data.completeData;

              this.global.Role = result.data.roleCode[0];
              // alert(this.global.Role);

              this.userId = result.data.userId;
              if (this.global.Role == "PATIENT") {
                this._PatientService.getPatientById(this.userId).subscribe(
                  (data: any) => {
                    console.log(data);
                    if (data.status != -1) {
                      this.patientActive = data.data.isActive;
                      if (this.patientActive) {
                        this.global.spinner = false;

                        if (this.destination) {
                          this.router.navigateByUrl(this.destination);
                        }
                        else {
                          this.router.navigateByUrl("/landind");
                        }

                      }
                      else {
                        this.openDailog()
                      }

                    }
                  },
                  (error: any) => {
                    console.log(error);
                    this.global.spinner = false;

                    //this.toastr.error('حدث خطأ ما');
                  }
                )

              } else {
                this.router.navigateByUrl("/landind");

              }
              // alert(this.global.Role);
              /*this.permssionRole.GetPermssionsforRole(this.global.Role).toPromise().then(res=>
            {
              console.log(res);
                this.global.perms=((res as any).data as Permission[]);
              console.log(this.global.perms);
              console.log('perm');
                this.global.savePermissions();
                this.global.spinner=false;
0
                this.router.navigateByUrl("/landind");
            }
                );*/
              // if(result.data.roleCode[0] == "EmployeePatient" && !result.data.completeData)
              // if(this.global.isPatientRole()  && !result.data.completeData )


              console.log(this.errors);

            } else {
              // this.loginFailed=true;
              this.errors = true;
              this.global.spinner = false;

              this.toastr.error(result.messages[0].body);

              if (result.messages) {
                this.global.Messages = result.messages;
                this.global.spinner = false;

              }
              this.global.spinner = false;

              this.global.Messages = null;
            }
            this.global.spinner = false;

          },
          error => {
            this.errors = error;
            this.global.spinner = false;

          }
        );
    }
  }
  openDailog() {
    let dialogRef = this.dialog.open(ActivationUserComponent, {
      backdropClass: 'cdk-overlay-dark-backdrop',
      hasBackdrop: true, width: "550px", height: "580px",
      data: { userid: this.userId }
    });
    dialogRef.afterClosed().subscribe(res => {

    })
  }
  ngOnInit() {
    this.destination = new URLSearchParams(window.location.search).get("destination");
    this.registeredEmail = new URLSearchParams(window.location.search).get("email");
    if (this.registeredEmail) {
      this.credentials.email = this.registeredEmail;
    }
    //search();
    //Togglecard();
  }
  ngOnDestroy() {
    // prevent memory leak by unsubscribing
  }

  showPatientRecord(media) {
    // this.recordSource = `${environment.API_URL}/../${this.BehavioralVideQA.patientAnswers[0]}`;
    console.log("media Source : " + media);
    let mediaFile = "../../../assets/videos/" + media;
    let dialogRef = this.dialog.open(ViewPatientRecordComponent, {
      hasBackdrop: true,
      autoFocus: true,
      width: '70%',
      data: { recordSource: mediaFile }
    });
  }
}
